// extracted by mini-css-extract-plugin
export default {"plainLink":"Layout_plainLink__1w7a1","modal_bg":"Layout_modal_bg__3vfwj","cardLink":"Layout_cardLink__1n1u1","ignoreMe":"Layout_ignoreMe__7MHSB"};